import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
  events: localStorage.getItem('contents') && JSON.parse(localStorage.getItem('contents'))  || [],
};

const module = {
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/contents/index.js